import React from 'react';
import { Database } from 'lucide-react';
import CoursePage from './CoursePage';

const DataScienceCourse: React.FC = () => {
  const courseData = {
    title: 'Data Science',
    subheading: 'Insights from Data',
    description: 'Transform data into insights with statistical analysis, visualization, and predictive modeling. Master Python data science libraries including Pandas, NumPy, and Matplotlib.',
    punchLine: 'Transform raw data into powerful insights that drive business decisions and innovation!',
    color: '#10b981',
    gradient: 'linear-gradient(135deg, #10b981, #06b6d4)',
    students: '2.8K',
    duration: '14 weeks',
    lessons: 50,
    image: '📊',
    icon: <Database size={40} />,
    videos: [
      {
        id: 1,
        title: 'Python Data Science | Data Science Series | Introduction | Python Libraries | Data Science 1',
        description: 'Introduction to Python Data Science and essential libraries for data analysis',
        duration: '18:45',
        thumbnail: 'https://img.youtube.com/vi/VplmTJll1wk/maxresdefault.jpg',
        youtubeId: 'VplmTJll1wk',
        timestamp: '0s'
      },
      {
        id: 2,
        title: 'Python Data Science | Data Science 2',
        description: 'Advanced concepts in Python Data Science and data manipulation techniques',
        duration: '22:30',
        thumbnail: 'https://img.youtube.com/vi/JnG_ORJwkrI/maxresdefault.jpg',
        youtubeId: 'JnG_ORJwkrI',
        timestamp: '0s'
      },
      {
        id: 3,
        title: 'Python Data Science | Data Science 3 | Series & DataFrames',
        description: 'Understanding Pandas Series and DataFrames for data manipulation',
        duration: '25:15',
        thumbnail: 'https://img.youtube.com/vi/gDOYn_EE4bY/maxresdefault.jpg',
        youtubeId: 'gDOYn_EE4bY',
        timestamp: '0s'
      },
      {
        id: 4,
        title: 'Python Data Science | Data Science 4 | Dataframes CRUD Operations',
        description: 'Create, Read, Update, and Delete operations on DataFrames',
        duration: '20:40',
        thumbnail: 'https://img.youtube.com/vi/Wb5sTMtbm2I/maxresdefault.jpg',
        youtubeId: 'Wb5sTMtbm2I',
        timestamp: '0s'
      },
      {
        id: 5,
        title: 'Python Data Science | Data Science 5 | Pandas CSV | Part01',
        description: 'Working with CSV files using Pandas - Part 1',
        duration: '16:25',
        thumbnail: 'https://img.youtube.com/vi/J0dlxKbTfL4/maxresdefault.jpg',
        youtubeId: 'J0dlxKbTfL4',
        timestamp: '0s'
      },
      {
        id: 6,
        title: 'Python Data Science | Data Science 6 | Pandas CSV | Part02',
        description: 'Advanced CSV operations and data processing with Pandas - Part 2',
        duration: '19:50',
        thumbnail: 'https://img.youtube.com/vi/zfLucgHRZT0/maxresdefault.jpg',
        youtubeId: 'zfLucgHRZT0',
        timestamp: '0s'
      },
      {
        id: 7,
        title: 'Python Data Science | Data Science 7 | Pandas Excel | Part01',
        description: 'Working with Excel files using Pandas - Part 1',
        duration: '17:35',
        thumbnail: 'https://img.youtube.com/vi/0pw-ayKXDI4/maxresdefault.jpg',
        youtubeId: '0pw-ayKXDI4',
        timestamp: '0s'
      },
      {
        id: 8,
        title: 'Python Data Science | Data Science 8 | Pandas Excel | Part02',
        description: 'Advanced Excel operations and data analysis with Pandas - Part 2',
        duration: '21:20',
        thumbnail: 'https://img.youtube.com/vi/Z6-VzldB-Bo/maxresdefault.jpg',
        youtubeId: 'Z6-VzldB-Bo',
        timestamp: '0s'
      },
      {
        id: 9,
        title: 'Python Data Science | Data Science 9 | Handling Missing Data',
        description: 'Techniques for identifying and handling missing data in datasets',
        duration: '24:10',
        thumbnail: 'https://img.youtube.com/vi/cBGLzLZ-M1Q/maxresdefault.jpg',
        youtubeId: 'cBGLzLZ-M1Q',
        timestamp: '0s'
      },
      {
        id: 10,
        title: 'Python Data Science | Data Science 10 | Pandas GroupBy',
        description: 'Master Pandas GroupBy operations for data aggregation and analysis',
        duration: '26:45',
        thumbnail: 'https://img.youtube.com/vi/c4uX-u14knk/maxresdefault.jpg',
        youtubeId: 'c4uX-u14knk',
        timestamp: '0s'
      },
      {
        id: 11,
        title: 'Python Data Science | Data Science 11 | Pandas Concatenation',
        description: 'Combining and concatenating DataFrames using Pandas',
        duration: '18:30',
        thumbnail: 'https://img.youtube.com/vi/ejv5FwEGJ3s/maxresdefault.jpg',
        youtubeId: 'ejv5FwEGJ3s',
        timestamp: '0s'
      },
      {
        id: 12,
        title: 'Python Data Science | Data Science 12 | Pandas Working with JSON',
        description: 'Working with JSON data using Pandas for data analysis',
        duration: '23:15',
        thumbnail: 'https://img.youtube.com/vi/9qSiWMJoiA8/maxresdefault.jpg',
        youtubeId: '9qSiWMJoiA8',
        timestamp: '0s'
      }
    ]
  };

  return <CoursePage {...courseData} />;
};

export default DataScienceCourse;
